<template>
  <v-snackbar
    v-if="notifications"
    v-model="show"
    :timeout="timeout"
    :color="notificationColor(generalExApplicationEx)"
    :centered="notificationAlertCentered(generalExApplicationEx)"
    :rounded="notificationAlertCentered(generalExApplicationEx) ? null : 'pill'"
  >
    <div v-for="(notification, index) in styledNotifications()" :key="index">

      <v-alert
        v-if="notificationAlertCentered(generalExApplicationEx)"
        :type="dialogType(notification.custom)"
        outlined
      >
        {{ notification.text }}
      </v-alert>

      <v-layout
        align-center
        pr-4
        v-if="notificationLayoutBottom(generalExApplicationEx)"
      >
        <v-icon class="pr-3" dark :color="notification.iconColor">{{
          notification.icon
        }}</v-icon>
        <v-layout column>
          <div>{{ notification.text }}</div>
        </v-layout>
      </v-layout>
    </div>
  </v-snackbar>
</template>

<script>
export default {
  name: "Notification",
  props: ["notifications", "generalExApplicationEx"],
  data() {
    return {
      show: false,
      timeout: 3000,
    };
  },
  methods: {
    open() {
      this.show = true;
    },
    styledNotifications() {
      return this.notifications.map((notification) => {
        switch (notification.custom) {
          case "error": {
            return {
              icon: "mdi-alert",
              text: notification.content,
              iconColor: this.errorColor(),
              custom: notification.custom
            };
          }
          case "info":
            return {
              icon: "mdi-information",
              text: notification.content,
              iconColor: this.infoColor(),
              custom: notification.custom
            };
          case "warning":
            return {
              icon: "mdi-exclamation",
              text: notification.content,
              iconColor: this.warningColor(),
              custom: notification.custom
            };
          case "success":
          default:
            return {
              icon: "mdi-check-circle",
              text: notification.content,
              iconColor: this.successColor(),
              custom: notification.custom
            };
        }
      });
    },
  },
  updated() {
    
  },
};
</script>

<style>
</style>